import axiosInstance from '../config/axiosConfig';

export async function getUserProfile() {
    try {
        const response = await axiosInstance.get(`/user/info`);
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        console.error('Error inviting user', error);
        return {
            success: false,
            error,
        };
    }
}
